import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  position: relative;
`;

export const TopBar = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 12px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RefreshButton = styled(ActionButton)`
  background: #e3f2fd;
  color: #1976d2;

  &:hover:not(:disabled) {
    background: #bbdefb;
  }
`;

export const LogoutButton = styled(ActionButton)`
  background: #ffebee;
  color: #c62828;

  &:hover:not(:disabled) {
    background: #ffcdd2;
  }
`;

export const WelcomeText = styled.h1`
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 600;
`;

export const SubText = styled.p`
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 48px;
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const BigButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 280px;
  height: 200px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(-4px);
  }
`;

export const DashboardButton = styled(BigButton)`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  &:hover {
    background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
  }
`;

export const PortalButton = styled(BigButton)`
  background: linear-gradient(135deg, #F1AF59 0%, #e89a3e 100%);

  &:hover {
    background: linear-gradient(135deg, #e8a24e 0%, #d68a30 100%);
  }
`;

export const ButtonIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

export const ButtonTitle = styled.span`
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
`;

export const ButtonDescription = styled.span`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
  padding: 0 20px;
`;
